import { z } from 'zod';
import { automationLevelSchema } from '@rossum/api-client/queues';
import { unifyDecimalSeparator } from '../core/utils';

// coerce.number converts "" into 0 which causes problems
export const thresholdSchema = z.preprocess(val => {
  if (val === '' || val === null || val === undefined) return null;

  return typeof val === 'string' ? unifyDecimalSeparator(val) : val;
}, z.coerce.number().min(0).max(1).nullable());

export const formSchema = z.object({
  defaultScoreThreshold: z.number(),
  qualitySpotCheckPercentage: z.number(),
  automationLevel: automationLevelSchema,
  thresholdValues: z.record(thresholdSchema),
});
